import { EnumConfig } from 'angular-odata';

//#region ODataApi Imports
import { PhaseType } from './phasetype.enum';
//#endregion

export const PhaseTypeConfig = {
  name: "PhaseType",
  members: PhaseType
} as EnumConfig<PhaseType>;